import { useEffect } from "react";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useAuthStore } from "@/stores/authStore";

const PENCOM_LOGO = "/assets/images/onboarding/pencom_logo_transparent.png";

const MaintenancePage = ({ message }: { message: string | null }) => {
  const { trackEvent, eventNames } = useAnalytics();

  useEffect(() => {
    const employer = useAuthStore.getState().currentEmployer;
    trackEvent(eventNames.maintenancePageShown, {
      employerCode: employer?.employerCode,
      hasCustomMessage: Boolean(message),
    });
    // Fire once per mount; deliberately ignore message/employer changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="min-h-screen w-full bg-off-white flex flex-col items-center justify-center px-6 py-10"
    >
      <div className="w-full max-w-[520px] flex flex-col items-center text-center">
        <img
          src={PENCOM_LOGO}
          alt="PenCom"
          className="h-[88px] w-auto object-contain mb-8"
          loading="eager"
        />

        <h1 className="font-clash-display font-semibold text-3xl md:text-[36px] text-medium-dark-grey leading-[1.2] tracking-[-0.6px]">
          We&apos;ll be back shortly
        </h1>

        <p className="mt-4 font-clash-display text-base md:text-lg text-medium-grey leading-relaxed">
          {message ||
            "The PenCom Employer Hub is undergoing scheduled maintenance. Please check back in a little while — your data is safe and no action is required from you."}
        </p>

        <p className="mt-10 font-clash-display text-sm text-medium-grey">
          © {new Date().getFullYear()} National Pension Commission
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
